export type PriceCheckEventLineDraft = {
  itemId: string;
  itemCode: string;
  itemName: string;
  productId: string | null;
  productCode: string | null;
  qty: number;
  unitPrice: number | null;
  chargeDays: number;
  usageRoomDate: string;
  note?: string | null;
};

export type PriceCheckEventDraft = {
  createdAt: string;
  siteLocationId: string | null;
  startDate: string;
  endDate: string;
  estimatedDeliveryCost: number;
  showDamageDeposits: boolean;
  lines: PriceCheckEventLineDraft[];
};

const STORAGE_PREFIX = 'price-check-event-draft:';

const buildStorageKey = (draftKey: string) => `${STORAGE_PREFIX}${draftKey}`;

export const savePriceCheckEventDraft = (draft: PriceCheckEventDraft): string => {
  const draftKey = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  try {
    window.sessionStorage.setItem(buildStorageKey(draftKey), JSON.stringify(draft));
  } catch (error) {
    console.warn('Unable to persist price-check draft', error);
  }
  return draftKey;
};

export const readPriceCheckEventDraft = (draftKey: string | null | undefined): PriceCheckEventDraft | null => {
  if (!draftKey) return null;
  try {
    const raw = window.sessionStorage.getItem(buildStorageKey(draftKey));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PriceCheckEventDraft;
    if (!parsed || !Array.isArray(parsed.lines)) return null;
    return parsed;
  } catch (error) {
    console.warn('Unable to parse price-check draft', error);
    return null;
  }
};

export const removePriceCheckEventDraft = (draftKey: string | null | undefined): void => {
  if (!draftKey) return;
  try {
    window.sessionStorage.removeItem(buildStorageKey(draftKey));
  } catch (error) {
    console.warn('Unable to clear price-check draft', error);
  }
};
